const rankingItems = [
  { rank: 1, title: '星际迷航：新纪元', category: '科幻', hot: '9.8', trend: 'up', icon: 'ri-medal-line', color: 'text-accent-500' },
  { rank: 2, title: '古城谜案', category: '悬疑', hot: '9.6', trend: 'up', icon: 'ri-medal-line', color: 'text-secondary-400' },
  { rank: 3, title: '热血拳王', category: '动作', hot: '9.5', trend: 'up', icon: 'ri-medal-line', color: 'text-primary-500' },
  { rank: 4, title: '深海奇缘', category: '动画', hot: '9.3', trend: 'stable', icon: '', color: '' },
  { rank: 5, title: '极速追击', category: '动作', hot: '9.1', trend: 'up', icon: '', color: '' },
  { rank: 6, title: '午夜回响', category: '恐怖', hot: '8.9', trend: 'down', icon: '', color: '' },
  { rank: 7, title: '长安十二夜', category: '古装', hot: '8.7', trend: 'up', icon: '', color: '' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">热播榜单</h2>
          <p className="text-sm text-foreground-500">本周影迷热追影片TOP7，热度数据实时更新</p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="space-y-3">
            {rankingItems.map((item) => (
              <div
                key={item.rank}
                className="flex items-center gap-4 bg-background-100 rounded-xl p-4 border border-background-200/70 hover:border-accent-300/60 transition-all duration-300 cursor-pointer group"
              >
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-xl bg-background-50">
                  {item.icon ? (
                    <i className={`${item.icon} text-xl ${item.color}`}></i>
                  ) : (
                    <span className="text-sm font-bold text-foreground-400">{item.rank}</span>
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-400">{item.category}</span>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                  <span className="text-sm font-bold text-accent-500 font-heading">{item.hot}</span>
                  {item.trend === 'up' && (
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-arrow-up-line text-xs text-primary-500"></i>
                    </div>
                  )}
                  {item.trend === 'down' && (
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-arrow-down-line text-xs text-foreground-400"></i>
                    </div>
                  )}
                  {item.trend === 'stable' && (
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-subtract-line text-xs text-foreground-400"></i>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-8">
            <a
              href="#hero"
              className="inline-flex items-center gap-1 text-sm text-accent-600 hover:text-accent-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              查看完整榜单 <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}